import { CustomIcon, Notification } from '@components/shared';
import { useTranslation, Trans } from 'react-i18next';
import { RawCheckbox } from '@components/shared/forms';
import routes from '@root/routes';
import { TourbookSummary, Listing, SearchListing, BuildingListing } from '@root/types';
import s from './TourbookOverlay.module.less';

type Props = {
  tourbooks: TourbookSummary[];
  addListingToTourbook: (args: {
    tourbookId: string;
    listingId: string;
    onSuccess: (tourbook: TourbookSummary) => void;
  }) => Promise<void>;
  removeListingFromTourbook: (args: {
    tourbookId: string;
    listingId: string;
    onSuccess: (tourbook: TourbookSummary) => void;
  }) => Promise<void>;
  close: () => void;
  listing: Listing | SearchListing | BuildingListing;
  goToCreateCard: () => void;
};

export default function ToggleCard({
  tourbooks,
  addListingToTourbook,
  removeListingFromTourbook,
  close,
  listing,
  goToCreateCard,
}: Props) {
  const { t } = useTranslation('tourbook');
  return (
    <>
      <section className={s.header}>
        <button
          data-testid="goToNewTourbookButton"
          type="button"
          onClick={goToCreateCard}
          className={s.headerButton}
        >
          <CustomIcon type="plus" />
        </button>
        <h3>{t('manageDialogs.addToTourbook')}</h3>
        <button title="Close Overlay" onClick={close} type="button">
          <CustomIcon type="close" />
        </button>
      </section>
      <section className={s.body}>
        <ul className={s.tourbookList}>
          {tourbooks.map(tourbook => (
            <li className={s.tourbookRow} key={tourbook.id}>
              <RawCheckbox
                labelClassName={s.tourbookCheckboxLabel}
                className={s.tourbookCheckboxText}
                checked={tourbook.listingIds.includes(listing.id)}
                onChange={() => {
                  if (!tourbook.listingIds.includes(listing.id)) {
                    addListingToTourbook({
                      tourbookId: tourbook.id,
                      listingId: listing.id,
                      onSuccess: () => {
                        Notification.info({
                          title: t('toasts.listingAddedTitle'),
                          /* eslint-disable react/jsx-no-literals */
                          text: (
                            <Trans ns="tourbook" i18nKey="toasts.listingAddedText">
                              View in your <a href={routes.tourbooks}>Tourbooks</a>
                            </Trans>
                          ),
                          /* eslint-enable react/jsx-no-literals */
                          placement: 'bottomLeft',
                          duration: 3.5,
                        });
                      },
                    });
                  } else {
                    removeListingFromTourbook({
                      tourbookId: tourbook.id,
                      listingId: listing.id,
                      onSuccess: () => {
                        Notification.info({
                          title: t('toasts.listingRemoved'),
                          placement: 'bottomLeft',
                          duration: 3.5,
                        });
                      },
                    });
                  }
                }}
                horizontal
              >
                {tourbook.name}
              </RawCheckbox>
            </li>
          ))}
        </ul>
      </section>
    </>
  );
}
